import { effect, inject, untracked, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Constants } from '@helper/constants';
import { WindowDetectService } from '@service/window-detect.service';
import { LoadMoreService } from '@service/load-more.service';
import { HeaderBarComponent } from '@common/header-bar/header-bar.component';

export abstract class BaseLoadMoreComponent {
  readonly windowService = inject(WindowDetectService);
  readonly loadMoreService = inject(LoadMoreService);
  readonly fixedTabPaddingTop = Constants.MOBILE_HEADER_BAR_WITH_TAB_HEIGHT;
  readonly fixedPaddingTop = HeaderBarComponent.height;

  private loadMoreCount = 0;

  protected constructor(
    private itemCount: WritableSignal<number>,
    defaultCount: number,
    loadMoreCount = 0,
    keepLoadMoreCount = true
  ) {
    this.loadMoreCount = loadMoreCount;
    if (!this.loadMoreCount) {
      this.loadMoreCount = Constants.loadMoreCount(this.windowService.isMobileDevice());
    }
    if (keepLoadMoreCount) {
      effect(() =>
        this.loadMoreService.setItemCount(
          untracked(() => this.windowService.currentPath()),
          itemCount()
        )
      );
    }
    effect(() => {
      const path = this.windowService.currentPath();
      if (path) {
        itemCount.set(this.loadMoreService.getItemCount(path, defaultCount));
      }
    });
    // restore load more count
    itemCount.set(this.loadMoreService.getItemCount(this.windowService.currentPath(), defaultCount));
    // subscribe load more.
    this.loadMore();
  }

  clearLoadMoreCount(displayCount = Constants.displayCount(this.windowService.isMobileDevice())): void {
    this.itemCount.set(displayCount);
    this.loadMoreService.clearItemCount();
  }

  // 很特殊的可以自己 override.
  protected loadMore(): void {
    this.windowService.loadMore.pipe(takeUntilDestroyed()).subscribe(() => {
      this.itemCount.update(value => Math.min(value + this.loadMoreCount, Constants.MAX_DISPLAY_COUNT));
    });
  }
}
